// Gerado por `pnpm modules:sync` a partir dos module.json (ADR 0123). Não edite à mão.
import type {
  LocalizedText,
  PermissionDefinition,
  SystemRoleDefinition,
} from '../permissions.ts';
import * as customers from './customers/index.ts';
import * as orders from './orders/index.ts';
import * as suppliers from './suppliers/index.ts';
import * as purchases from './purchases/index.ts';

/** Os módulos instalados, na ordem das dependências. */
export const INSTALLED_MODULES = [
  {
    id: 'customers',
    version: '1.1.0',
    name: { 'pt-BR': 'Clientes', en: 'Customers' },
    depends: [],
  },
  {
    id: 'orders',
    version: '1.1.0',
    name: { 'pt-BR': 'Pedidos', en: 'Orders' },
    depends: ['customers'],
  },
  {
    id: 'suppliers',
    version: '1.1.0',
    name: { 'pt-BR': 'Fornecedores', en: 'Suppliers' },
    depends: [],
  },
  {
    id: 'purchases',
    version: '1.1.0',
    name: { 'pt-BR': 'Compras', en: 'Purchases' },
    depends: ['suppliers'],
  },
] as const;

export const MODULE_PERMISSION_MODULES: Record<string, LocalizedText> = {
  ...customers.PERMISSION_MODULES,
  ...orders.PERMISSION_MODULES,
  ...suppliers.PERMISSION_MODULES,
  ...purchases.PERMISSION_MODULES,
};

export const MODULE_PERMISSIONS = [
  ...customers.PERMISSIONS,
  ...orders.PERMISSIONS,
  ...suppliers.PERMISSIONS,
  ...purchases.PERMISSIONS,
] as const satisfies readonly PermissionDefinition[];

/** Perfis fixos que os módulos trazem (ADR 0131); o seed os cria e mantém. */
export const MODULE_SYSTEM_ROLES: readonly SystemRoleDefinition[] = [
  ...((customers as { SYSTEM_ROLES?: readonly SystemRoleDefinition[] }).SYSTEM_ROLES ?? []),
  ...((orders as { SYSTEM_ROLES?: readonly SystemRoleDefinition[] }).SYSTEM_ROLES ?? []),
  ...((suppliers as { SYSTEM_ROLES?: readonly SystemRoleDefinition[] }).SYSTEM_ROLES ?? []),
  ...((purchases as { SYSTEM_ROLES?: readonly SystemRoleDefinition[] }).SYSTEM_ROLES ?? []),
];
